import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Box, Icon } from '@elparking/components'

import { MUTUAMAS_SERVICES_CONDITIONS } from 'commons/js/constants'
import { IconContainer } from 'rental-car-contract/js/ui/IconContainer'

const InfoAgeRequirements = ({containerProps}) => {
    return <Flex mb='1em' backgroundColor='accent10' padding='0.5em' {...containerProps}>
        <IconContainer backgroundColor='accent_dark10'>
            <Icon type='info' size='small' fontColor='success_dark' />
        </IconContainer>
        <Box ml='0.5em'>
            <Copy padding='0' fontWeight='regular'><FormattedMessage defaultMessage='Recuerda que para poder recoger tu vehículo deberás cumplir con los requisitos de edad de la compañía. Puedes consultar los {termsAndConditions}.' values={{
                    termsAndConditions: <Copy as='a' fontSize='xxSmall' fontColor='main' href={MUTUAMAS_SERVICES_CONDITIONS} target='_blank'><FormattedMessage defaultMessage='términos y condiciones' /></Copy>,
                    }}
                /></Copy>
        </Box>
    </Flex>
}

InfoAgeRequirements.propTypes = {
    containerProps: PropTypes.object,

}

InfoAgeRequirements.defaultProps = {
    containerProps: {},

}

export default InfoAgeRequirements
